import { render, staticRenderFns } from "./SystemOverview.vue?vue&type=template&id=4c9d5b42&scoped=true"
import script from "./SystemOverview.vue?vue&type=script&lang=ts"
export * from "./SystemOverview.vue?vue&type=script&lang=ts"
import style0 from "./SystemOverview.vue?vue&type=style&index=0&id=4c9d5b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d5b42",
  null
  
)

export default component.exports